<template>
    <div class="col-sm-12">
        <div
            class="data-list-item add"
            @click.stop="$emit('add')"
        >
            <div class="item-img-cont add-title">
                <i class="fa fa-plus" />
            </div>
            <div class="item-text-cont">
                <span class="item-title-add">{{ $t('common.add_new') }}</span>
                <font-awesome-icon
                    icon="wrench"
                    class="card-body-icon"
                />
            </div>
        </div>
        <Transition name="fade">
            <!-- Main table element -->
            <div v-if="defects && defects.length > 0" class="col-sm-12 list-content result-table">
                <vue3-datatable
                    ref="resultTable"
                    :rows="defects"
                    :columns="fields"
                    :pagination="false"
                    :sticky-header="true"
                    :sortable="true"
                    :height="defects.length > 8 ? '50vh' : '100%'"
                    skin="bh-table-compact"
                    :row-class="getRowClass"
                    cell-class="routa-table-cell"
                    @row-click="emitDetails"
                >
                    <template #created="row">
                        {{ row.value && row.value.created ? toLocalTime(row.value.created) : '' }}
                    </template>
                    <template #fixed="row">
                        {{ row.value && row.value.fixed ? toLocalTime(row.value.fixed) : '' }}
                    </template>
                </vue3-datatable>
            </div>
        </transition>
    </div>
</template>

<script>
import {timeUtils} from '../../mixins/TimeUtils'
import Vue3Datatable from "@bhplugin/vue3-datatable";

export default {
    name: 'AreaDefectList',
    components: {Vue3Datatable},
    mixins: [timeUtils],
    props: {
        items: {
            type: Array,
            default() {
                return []
            }
        }
    },
    data: function () {
        return {
            sortBy: 'created',
            sortDesc: true,
            sortDirection: 'asc',
            fields: [
                {field: 'created', title: this.$t('defects.created'), sort: true, headerClass: 'routa-table-header'},
                {field: 'area_name', title: this.$t('area_defects.area_name'), sort: true, headerClass: 'routa-table-header'},
                {field: 'area_equipment', title: this.$t('area_defects.equipment'), sort: true, headerClass: 'routa-table-header'},
                {field: 'reporter', title: this.$t('defects.reporter'), sort: true, headerClass: 'routa-table-header'},
                {field: 'description', title: this.$t('defects.description'), sort: true, headerClass: 'routa-table-header'},
                {field: 'defect_status', title: this.$t('defects.status'), sort: true, headerClass: 'routa-table-header'},
                {field: 'fixed', title: this.$t('defects.fixed'), sort: true, headerClass: 'routa-table-header'},
                {field: 'fixed_by', title: this.$t('defects.fixed_by'), sort: true, headerClass: 'routa-table-header'}
            ],
            defects: []
        }
    },
    watch: {
        items: function () {
            this.initTableItems()
        }
    },
    methods: {
        getRowClass(row) {
            switch (row.status) {
                case 2: return 'routa-table-row selected-row'
                case 3: return 'routa-table-row warning-row'
                case 4: return 'routa-table-row danger-row'
            }
            return 'routa-table-row'
        },

        initTableItems: function () {
            this.defects = []
            let temp = []
            this.items.forEach(item => {
                temp.push({
                    id: item.id,
                    area_name: item.area ? item.area.name : '',
                    area_equipment: item.area_equipment ? item.area_equipment.name : '',
                    reporter: item.reporter ? item.reporter.last_name + ', ' + item.reporter.first_name : '',
                    created: item.created_date,
                    description: item.description,
                    defect_status: this.getDefectStatusString(item.status),
                    fixed: item.fixed_date ? item.fixed_date : '',
                    fixed_by: item.fixer ? item.fixer.last_name + ', ' + item.fixer.first_name : '',
                })
            })
            this.$nextTick(() => {
                this.defects = temp
            })
        },
        emitDetails: function (result) {
            // Find defect item from original items and emit request to edit
            let p = this.items.find(item => item.id === result.id)
            if (p) {
                this.$emit('edit', p)
            }
        },
        getDefectStatusString: function (status) {
            switch (status) {
                case 2:
                    return this.$t('inspection.options.okay')
                case 3:
                    return this.$t('inspection.options.defects')
                case 4:
                    return this.$t('inspection.options.ban')
            }
            return '-'
        }
    }
}
</script>

<style scoped>

</style>
